(() => {
  const originalCopy = document.querySelector('[data-joa-global-option-copy]');
  let globalCopy = {};
  try { globalCopy = JSON.parse(originalCopy?.textContent || '{}'); } catch (_) {}
  const setText = (node, value) => { if (node.textContent !== value) node.textContent = value; };
  function parseMoney(value) {
    const match = value?.match(/-?\d[\d\s.,'’]*/);
    if (!match) return null;
    const raw = match[0].trim();
    const decimal = raw.match(/([.,])(\d{1,2})$/);
    const integer = decimal ? raw.slice(0, -decimal[0].length) : raw;
    const amount = Number(integer.replace(/[^\d-]/g, '') + (decimal ? '.' + decimal[2] : ''));
    if (!Number.isFinite(amount)) return null;
    const format = cents => {
      const [whole, fraction] = (cents / 100).toFixed(2).split('.');
      const group = integer.match(/[^\d-]/)?.[0] || '';
      const grouped = group ? whole.replace(/\B(?=(\d{3})+(?!\d))/g, group) : whole;
      return value.slice(0, match.index) + grouped + (decimal?.[1] || '.') + fraction + value.slice(match.index + raw.length);
    };
    return { cents: Math.round(amount * 100), format };
  }
  function enhance(container) {
    const root = container.closest('.product-information,.joa-quick-ring,.mw-tingle');
    if (!root) return;
    const copyNode = root.querySelector('[data-joa-design-copy]');
    let copy = globalCopy;
    try { copy = { ...globalCopy, ...JSON.parse(copyNode?.textContent || '{}') }; } catch (_) {}
    const text = key => copy[key] || globalCopy[key] || key.replaceAll('_', ' ');
    const form = container.closest('form') || root.querySelector('product-form-component form');
    const summary = container.querySelector('.joa-design-summary') || form?.querySelector('.joa-design-summary') || root.querySelector('.joa-native-summary');
    if (!summary) return;
    summary.dataset.joaConfirmLater = text('config_confirm_later');
    const scope = root;
    const choice = scope.querySelector('input[name="selling_plan"]:checked, [data-joa-editor-plan]:checked');
    let rate = choice?.value ? Number(choice.dataset.depositRate) : 0;
    const paymentData = copyNode?.dataset.joaDepositPlan ? copyNode : originalCopy;
    if (scope.querySelector('#purchase-option-deposit-input:checked') && paymentData?.dataset.joaDepositPlan === scope.querySelector('#purchase-option-deposit-wrapper')?.dataset.sellingPlan) rate = Number(paymentData.dataset.joaDepositRate);
    const priceHost = root.querySelector('product-price,.mw-product-info__price,.joa-quick-ring__price');
    const display = window.JoaPriceDisplay?.read(priceHost);
    const money = parseMoney(display?.current);
    const hasDeposit = Boolean(money && rate > 0 && rate < 1);
    const stones = form?.querySelector('joa-birthstones');
    const editorExtra=Number(root.dataset.joaBirthstoneTotal)||0;
    const editorEligible=(root.dataset.joaBirthstonePlans||'').split(',').includes(choice?.value);
    const extraDue = stones?.due?.(rate) || (editorEligible?Math.round(editorExtra*rate):editorExtra);
    const now = hasDeposit ? money.format(Math.round(money.cents * rate) + extraDue) : '';
    summary.dataset.joaDueNow = now;
    summary.dataset.joaDueNowLabel = text('due_now');
    summary.classList.toggle('joa-conversion-deposit', hasDeposit);
    summary.querySelector('.joa-conversion-payment')?.remove();
    if (form) {
      const action = hasDeposit ? text('deposit_action').replace('[amount]', now) : text('add_cart_action');
      form.dataset.joaPurchaseLabel = action;
      for (const button of form.querySelectorAll('button.add-to-cart-button')) {
        const label = button.querySelector('.add-to-cart-text');
        if (!label || button.dataset.joaCartState === 'success') continue;
        let words = label.querySelector('[data-joa-action-copy]');
        if (!words) {
          words = document.createElement('span'); words.dataset.joaActionCopy = '';
          for (const node of [...label.childNodes]) if (node.nodeType === Node.TEXT_NODE) node.remove();
          label.append(words);
        }
        button.classList.toggle('joa-deposit-button', hasDeposit);
        if (button.getAttribute('aria-label') !== action) button.setAttribute('aria-label', action);
        if (hasDeposit) {
          if (!words.querySelector('.joa-action-title')) {
            const title = document.createElement('span'); title.className = 'joa-action-title';
            const amount = document.createElement('span'); amount.className = 'joa-action-amount';
            words.replaceChildren(title, amount);
          }
          setText(words.children[0], text('add_cart_action'));
          setText(words.children[1], text('deposit_amount_action').replace('[amount]', now));
        } else setText(words, action);
      }
    }
  }
  document.addEventListener('joa:options-designed', event => {
    if (event.target instanceof Element && event.target.matches('.mw-apo-container')) enhance(event.target);
  });
  document.addEventListener('joa:birthstones-change', () => document.querySelectorAll('.mw-apo-container[data-joa-option-design]').forEach(enhance));
  document.addEventListener('joa:native-options-designed', event => enhance(event.detail.root));
  document.querySelectorAll('.mw-apo-container[data-joa-option-design]').forEach(enhance);
})();
